import {Component} from "react";
import EventBus from "../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import CCButton from "./Common/CCButton";
import css_buttons from "./Common/css/CCButton.module.scss";
import {makeEnterpriseComponent} from "../util/utility";
import DocumentRevisionTableApplet from "../eoec/applet/impl/General/DocumentRevisionTableApplet";
import {withAppContext} from "../util/withAppContext";


class EnlilLongSelect extends Component {

    constructor(props) {
        super(props);

        this.enterpriseComponent = makeEnterpriseComponent(this.props.pickList.getEnterpriseComponent());
    };

    enterpriseComponentLoadStarted = () => {
        this.setState({fetchBackgroundOperation: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
    };

    componentDidMount() {
        this.enterpriseComponent.addLoadStartedListener(this);
        this.enterpriseComponent.addLoadCompletedListener(this);
    }

    componentWillUnmount() {
        this.enterpriseComponent.removeAllListeners(this);
    }

    onCancelHandler() {
        EventBus.components.emit("long-select-cancel");
    }

    render() {
        let buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                <CCButton
                    className={css_buttons.redStandardButton}
                    onClick={this.onCancelHandler}>
                    Cancel
                </CCButton>
                <CCButton
                    className={css_buttons.blueStandardButton}
                    onClick={() => this.selectHandler()}>
                    Select
                </CCButton>
            </DialogActions>
        );

        return (
            <>
                <Dialog open={true} scroll="body" fullWidth={true} maxWidth="lg">
                    <DialogTitle>Select</DialogTitle>
                    <DialogContent>
                        <div style={{marginTop: "20px", marginBottom: "20px"}}>
                            <DocumentRevisionTableApplet enterpriseComponent={this.enterpriseComponent}/>
                        </div>
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        )
    }

    selectHandler() {
        let targetEnterpriseComponentAttribute = this.props.targetEnterpriseComponentAttribute;

        for (let i = 0; i < targetEnterpriseComponentAttribute.getPickMaps().length; i++) {
            let pickMap = targetEnterpriseComponentAttribute.getPickMaps()[i];
            this.props.targetEnterpriseComponent.setAttributeValue(pickMap.getAttribute(), this.enterpriseComponent.getAttributeValue(pickMap.getPickListAttribute()));
        }
        this.props.targetEnterpriseComponent.notifyPickCompletedListeners();

        EventBus.components.emit("long-select-select");
    };

}

export default withAppContext(EnlilLongSelect);
